import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

export function LoadingSpinner({
  size = 20,
  className = '',
  strokeWidth = 2.5,
}) {
  return (
    <>
      <Loader2
        className={cn('animate-spin text-white', className)}
        size={size}
        strokeWidth={strokeWidth}
      />
      <span className="sr-only">Loading...</span>
    </>
  );
}
